import { ajax } from '../../../services/helper'

class ApiService {
    


    getProductsData = (city_id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/products/getList?list=Kit&city_id="+city_id
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


     getCityDetailList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/cities/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    getSellingStoresDetails = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/products/"+id+"/sellingStores"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    listMarkedProductSelling = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/stores/"+id+"/listMarkedProductSelling"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     postStoresKitsUpdate = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/storeKits/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


     getKitsProductsById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/kits/"+id+"/products"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    listMarkedProducts = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/kits/"+id+"/listMarkedProducts"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    postProductsKitsUpdate = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/kitProducts/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    
}

export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Kits/services/apiservices.js